import type { MatterFieldsFragment, MyMatterExpertsQuery } from '~/gql/graphql';
import {
  MatterStatus,
  TravelPlans,
  WrittenReportNeeded,
  MatterExpertStatus,
} from '~/gql/graphql';

export type MatterViewModel = MatterFieldsFragment;

export type MatterExpertRow = NonNullable<
  MatterViewModel['matterExperts']
>[number];

/** Row from `myMatterExperts` (picker / create-matter lists). */
export type MyMatterExpertsRow =
  MyMatterExpertsQuery['myMatterExperts'][number];

// ---------------------------------------------------------------------------
// Display-label maps
// ---------------------------------------------------------------------------

export const matterStatusLabel: Record<MatterStatus, string> = {
  [MatterStatus.Active]: 'Active',
  [MatterStatus.Inactive]: 'Inactive',
  [MatterStatus.Closed]: 'Closed',
};

export const travelPlansLabel: Record<TravelPlans, string> = {
  [TravelPlans.Required]: 'Required',
  [TravelPlans.Desired]: 'Desired',
  [TravelPlans.NotApplicable]: 'Not applicable',
};

export const writtenReportNeededLabel: Record<WrittenReportNeeded, string> = {
  [WrittenReportNeeded.Yes]: 'Yes',
  [WrittenReportNeeded.No]: 'No',
  [WrittenReportNeeded.Maybe]: 'Maybe',
};

export const matterExpertStatusLabel: Record<MatterExpertStatus, string> = {
  [MatterExpertStatus.Invited]: 'Invited',
  [MatterExpertStatus.Hired]: 'Hired',
  [MatterExpertStatus.Declined]: 'Declined',
  [MatterExpertStatus.Removed]: 'Removed',
};
